import type {
  FilterVehiclesByDisablerStatus,
  LoadVehiclesFailed,
  LoadVehiclesRequest,
  LoadVehiclesSucceeded,
  LoadVehiclesWithOdometerFailed,
  LoadVehiclesWithOdometerRequest,
  LoadVehiclesWithOdometerSucceeded,
  OpenEtaPageFailed,
  OpenEtaPageRequest,
  OpenEtaPageSucceeded,
  UpdateVehicleTrackingFailed,
  UpdateVehicleTrackingRequest,
  UpdateVehicleTrackingSucceeded,
} from './actions';
import { VehicleActionTypes } from './vehicleActionTypes';

import type { Destination, ESN, Vehicle, VehiclesByDisablerStatus } from '@cobliteam/common-types';

export const loadVehiclesRequest = (): LoadVehiclesRequest => ({
  type: VehicleActionTypes.LOAD_VEHICLES_REQUEST,
});

export const loadVehiclesSucceeded = (vehicles: Vehicle[]): LoadVehiclesSucceeded => ({
  type: VehicleActionTypes.LOAD_VEHICLES_SUCCEEDED,
  payload: vehicles,
});

export const loadVehiclesFailed = (): LoadVehiclesFailed => ({
  type: VehicleActionTypes.LOAD_VEHICLES_FAILED,
});

export const loadVehiclesWithOdometerRequest = (): LoadVehiclesWithOdometerRequest => ({
  type: VehicleActionTypes.LOAD_VEHICLES_WITH_ODOMETER_REQUEST,
});

export const loadVehiclesWithOdometerSucceeded = (vehicles: Vehicle[]): LoadVehiclesWithOdometerSucceeded => ({
  type: VehicleActionTypes.LOAD_VEHICLES_WITH_ODOMETER_SUCCEEDED,
  payload: vehicles,
});

export const loadVehiclesWithOdometerFailed = (): LoadVehiclesWithOdometerFailed => ({
  type: VehicleActionTypes.LOAD_VEHICLES_WITH_ODOMETER_FAILED,
});

export const openEtaPageRequest = (destination: Destination, esn?: string): OpenEtaPageRequest => ({
  type: VehicleActionTypes.OPEN_ETA_PAGE_REQUEST,
  payload: { destination, esn },
});

export const openEtaPageSucceeded = (): OpenEtaPageSucceeded => ({
  type: VehicleActionTypes.OPEN_ETA_PAGE_SUCCEEDED,
});

export const openEtaPageFailed = (): OpenEtaPageFailed => ({
  type: VehicleActionTypes.OPEN_ETA_PAGE_FAILED,
});

export const updateVehicleTrackingRequest = (deviceId: ESN, destination: Destination, isTracking: boolean): UpdateVehicleTrackingRequest => ({
  type: VehicleActionTypes.UPDATE_VEHICLE_TRACKING_REQUEST,
  payload: { deviceId, destination, isTracking },
});

export const updateVehicleTrackingSucceeded = (): UpdateVehicleTrackingSucceeded => ({
  type: VehicleActionTypes.UPDATE_VEHICLE_TRACKING_SUCCEEDED,
});

export const updateVehicleTrackingFailed = (): UpdateVehicleTrackingFailed => ({
  type: VehicleActionTypes.UPDATE_VEHICLE_TRACKING_FAILED,
});

export const filterVehiclesByDisablerStatus = (vehiclesByDisablerStatus: VehiclesByDisablerStatus): FilterVehiclesByDisablerStatus => ({
  type: VehicleActionTypes.FILTER_VEHICLES_BY_DISABLER_STATUS,
  payload: vehiclesByDisablerStatus,
});
